import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    appVersion: "0.6.0",
    app_domain: process.env.VUE_APP_LOCAL_DOMAIN, // TODO fix envs
    api_url: process.env.VUE_APP_LOCAL_API, // TODO fix envs
    env: {
      app_domain: null,
      api_url: null,
      site_url: null,
    },
    layout: {
      card_class: "row-cols-1 row-cols-md-2",
      logo: "https://media.iamconnected.com/images/iac_oc_logo-gold.png",
    },
    loading: {
      number_to_load: 0,
      page: 0,
    },
    menu: {
      items: {},
    },
    notifications: {},
    preFlightData: {},
    profile: {
      status: 0,
    },
    profile_active: {},
    session_id: null,
    show_loading: 1,
    year: null,
  },
  mutations: {
    appDomainSet(state, data) {
      console.log("STORE:appDomainSet:" + data);
      this.state.app_domain = data;
    },
    appUrlSet(state, data) {
      console.log("STORE:appUrlSet:" + data);
      this.state.api_url = data;
    },
    envSet(state, data) {
      this.state.env.app_domain = data.app_domain;
      this.state.env.api_url = data.api_url;
      this.state.env.site_url = data.site_url;
    },
    layoutCardClassSet(state, data) {
      console.log("layoutCardClassSet");
      state.layout.card_class = data;
    },
    loadingSet(state, data) {
      console.log("loadingSet");
      state.loading.page = data;
    },
    loadingNumberTotalSet(state, data) {
      console.log("loadingSet");
      state.loading.number_to_load = data;
    },
    menuSet(state, data) {
      state.menu = data.menu;
    },
    notificationsSet(state, data) {
      state.notifications = data;
    },
    preFlightDataSet(state, data) {
      console.log("STORE:preFlightDataSet");
      state.preFlightData = data;
    },
    profileActiveSet(state, data) {
      console.log("STORE:profileActiveSet");
      state.profile_active = data;
    },
    profileSet(state, data) {
      console.log("STORE:profileSet");
      state.profile = data.profile;
      state.session_id = data.profile.session_id;
    },
    profileTimezoneSet(state, data) {
      console.log("STORE:profileTimezoneSet");
      console.log(state);
      console.log(data);
      state.profile.timezoneOffsetH = data.timezoneOffsetH;
    },
  },
  computed: {},
  actions: {},
  modules: {},
  getters: {
    appVersion: (state) => {
      return state.appVersion;
    },
    isLoggedIn: (state) => {
      var status = 0;
      if (typeof state.profile.status !== "undefined") {
        status = state.profile.status;
      }
      return status;
    },
    loadingStatus: (state) => {
      return state.loading.page;
    },
    menuGet: (state) => {
      return state.menu;
    },
    menuGetItems: (state) => {
      if (state.menu.items) {
        return state.menu.items;
      } else {
        return null;
      }
    },
    notificationsTotal: (state) => {
      var total = 0;
      for (const val of Object.values(state.notifications)) {
        total += val;
      }
      return total;
    },
    profileGet: (state) => {
      return state.profile;
    },
    profileGetUserlevel: (state) => {
      return parseInt(state.profile.level);
    },
    profileGetName: (state) => {
      if (state.profile.first_name !== null) {
        return state.profile.user_name;
      } else {
        return state.profile.first_name;
      }
    },
    profileId: (state) => {
      return state.profile.id;
    },
    profileUserName: (state) => {
      return state.profile.user_name;
    },
    serverDate: (state) => {
      return state.profile.server_date;
    },
    sessionIdGet: (state) => {
      return state.session_id;
    },
  },
});

export default store;
